import {
  AdsManagerConversionTagsConfig,
  AdsManagerRestaurantConversionsData
} from 'src/apollo/onlineOrdering'
import {
  formatToFacebook,
  formatToGoogleAnalytics,
  formatToGoogleAnalyticsSharedConsent
} from 'src/shared/components/common/ads_manager/adsManagerFormatters'

export const extractAdsPixelMeta = (
  adsManagerConversionTagsConfig?: AdsManagerConversionTagsConfig | null,
  ooEthycaAds?: boolean,
  marketingConsent?: boolean,
  analyticConsent?: boolean,
  gtmConsentDefaultDeny?: boolean
) => {
  if (!adsManagerConversionTagsConfig) {
    return []
  }

  return adsManagerConversionTagsConfig.restaurantConversionsDataList
    ?.map((conversionData: AdsManagerRestaurantConversionsData | null) => {
      const tagId = conversionData?.googleConversionsData?.tagId ?? ''
      const googleTag = gtmConsentDefaultDeny
        ? formatToGoogleAnalyticsSharedConsent(tagId)
        : formatToGoogleAnalytics(
            tagId,
            ooEthycaAds ?? false,
            marketingConsent ?? false,
            analyticConsent ?? false
          )
      const metaTag = formatToFacebook(
        conversionData?.metaConversionsData?.pixelId ?? '',
        ooEthycaAds ?? false,
        marketingConsent ?? false
      )
      return [googleTag, metaTag]
    })
    .flat()
    .filter((tag) => tag !== '')
}
